angular.module('userSettingsMod')

.controller('mcpServers', ['$scope', 'GhDialog', 'McpServersService', 'localizationService', 'cnfg', async function($scope, GhDialog, McpServersService, localizationService, cnfg) {
  const dictionary = localizationService.getDictionary('account_settings');
  $scope.translate = (word) => localizationService.translate(word, dictionary);

  $scope.mcpServers = [];

  const user = gudhub.storage.getUser();
  $scope.mcpEditorUrl = `${cnfg.mcp_core_url}editor?authkey=${encodeURIComponent(user.auth_key)}`;
  $scope.mcpAdminUrl = `${cnfg.mcp_core_url}admin?authkey=${encodeURIComponent(user.auth_key)}`;

  $scope.copiedEndpoint = '';

  $scope.copyEndpointUrl = async function (event, url, key) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const textarea = document.createElement('textarea');

        textarea.value = url;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';

        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }

      $scope.copiedEndpoint = key;
      $scope.$applyAsync();

      setTimeout(function () {
        $scope.copiedEndpoint = '';
        $scope.$applyAsync();
      }, 1500);
    } catch (error) {
      console.log('MCP endpoint URL copy error:', error);
    }
  };

  $scope.getMcpServers = async function() {
    try {
      $scope.mcpServers = await McpServersService.getList();
      $scope.$evalAsync();
    } catch (error) {
      console.log(error);
    }
  };

  $scope.showDialog = function() {
    GhDialog.show({
      position: 'center',
      toolbar: false,
      locals: {
        mcpServers: $scope.mcpServers,
        safeApply: () => $scope.$evalAsync()
      },
      template: {
        toolbar: '',
        resizable: false,
        content: `
          <div class="dialog-share-group add_mcp_server-popup">
            <span gh-icon="mcp 0D99FF 65px"></span>
            <p class="dialog-share-group__title">{{translate('Add MCP Server')}}</p>
          </div>

          <div class="dialog-share-group__content">
            <div class="dialog-share-group__content__input">
              <label for="mcp_server_name">{{translate('Server name')}}</label>
              <input
                id="mcp_server_name"
                ng-model="mcpServer.mcp_server_name"
                type="text"
                placeholder="Type server name here..."
              >
            </div>

            <p class="mcp-create-note">
              {{translate('Server URL will be generated automatically.')}}
            </p>

            <div ng-show="errMessage" class="error_message">
              {{errMessage}}
            </div>

            <div class="dialog-share-group__content__buttons">
              <button
                class="dialog-share-group__content__buttons__cancel btn btn-blue-reverse"
                ng-click="cancel()"
              >
                Cancel
              </button>

              <button
                class="dialog-share-group__content__buttons__add btn btn-blue"
                ng-click="addMcpServer()"
              >
                Add
              </button>
            </div>
          </div>
        `
      },
      controller: ['$scope', 'mcpServers', 'safeApply', 'localizationService', function($scope, mcpServers, safeApply, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.errMessage = '';

        $scope.mcpServer = {
          mcp_server_name: '',
          active: true,
          app_with_functions: '',
          field_id_with_functions: '',
          items_with_functions: []
        };

        $scope.addMcpServer = async function() {
          if (!$scope.mcpServer.mcp_server_name || !$scope.mcpServer.mcp_server_name.trim()) {
            $scope.errMessage = 'Please, type server name';
            return;
          }

          try {
            const createdMcpServer = await McpServersService.create($scope.mcpServer);

            mcpServers.push(createdMcpServer);
            safeApply();
            $scope.cancel();
          } catch (error) {
            console.log(error);
            $scope.errMessage = error.message || 'Something went wrong. Please, try again';
            $scope.$evalAsync();
          }
        };
      }]
    });
  };

  await $scope.getMcpServers();

}]);
